import React from 'react'
import {useEffect, useState} from 'react';
import Modal from '../modals/modal';
import './portfolio.css'

const Portfolio = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    fetch('https://rush-general-backend.onrender.com/projects')
        .then(response => response.json())
        .then(data => setProjects(data));

// empty dependency array means this effect will only run once (like componentDidMount in classes)
}, []);

  return (
	<section id="portfolio">
    <h5>My Recent Work</h5>
    <h2>Portfolio</h2>
    <div className="container portfolio__container">
      {
        
        projects.map((project) => 
          <article key={project._id} className="portfolio__item">
            <div className="portfolio__item-image">
              <img src={project.image} alt="" />
            </div>
            <h3>{project.name}</h3>
            <div className='portfolio__item-cta'>
              <a href= {project.github !== ""? project.github : "#!"} className={project.github !== ""? "btn" :  "btn disabled" } target= {project.github !== "" ? "_blank" : ""}>Github</a>
              <a href={project.livelink !== ""? project.livelink: "#!"} className={project.livelink !== ""? "btn btn-primary" :  "btn btn-primary disabled" } target= {project.livelink !== "" ? "_blank" : ""}>Live Demo</a>
            </div>
            <div className='portfolio__item-cta'>
              <Modal props={project}></Modal>
            </div>
         
         </article>

        )
      }
    </div>
  </section>
  )
}

export default Portfolio